import { BnModalMixin } from '../../common/bn-modal-mixin';
import { html, LitEntity } from '../../utility/lit-entity';
import '../../common/bn-loading';
import './location-reschedule';

class LocationRescheduleModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'location-reschedule-modal';
  }

  renderContents() {
    return html`
      <style>
        bn-modal#${this.id} {
          --modal-min-width: 40%;
          --modal-max-width: 80%;
          --modal-body-overflow-y: visible;
        }
      </style>
      <h3 slot="title">Reschedule Work Order Location</h3>
      ${this._renderBody()}
    `;
  }

  _renderBody() {
    const action = this.entity && this.entity.getActionByName('update-scheduled-for');
    if (!action) {
      return html`<bn-loading></bn-loading>`;
    }
    return html`
      <location-reschedule
        .href="${action.href}"
        @response="${this._onResponse}"
      ></location-reschedule>
    `;
  }

  _onResponse(e) {
    this.dispatchEvent(new CustomEvent('response'), { detail: e.detail, bubbles: true, composed: true });
    this.close();
  }
}

window.customElements.define('location-reschedule-modal', LocationRescheduleModal);
